import { db } from '../firebaseConfig';

const mixin = function() {
    return {
        data() {
            return {
                config: {
                    APP_BASE_URL: '',
                    FEATURE_BOTTOM_HERO_BACKGROUND_URL: '',
                    FEATURE_DESKTOP_IMAGE: '',
                    FEATURE_LAPTOP_IMAGE_1: '',
                    FEATURE_LAPTOP_IMAGE_2: '',
                    FEATURE_TOP_HERO_BACKGROUND_URL: '',
                    HOME_IMAGE: '',
                    HOW_IT_WORKS_DESKTOP_IMAGE: '',
                    HOW_IT_WORKS_DESKTOP_VIDEO: '',
                    HOW_IT_WORKS_MOBILE_IMAGE: '',
                    HOW_IT_WORKS_MOBILE_VIDEO: '',
                    KIOSK_AD_VIDEO: '',
                    KIOSK_INTRODUCTION_URL: '',
                    KIOSK_WALKTHROUGH_URL: '',
                    LOGO_PNG: '',
                    MANDRILL_MESSAGES_SEND_TEMPLATE_API: '',
                    MOBILE_SURVEY_WALKTHROUGH_URL: '',
                    SURVEY_CONTENT_URL: '',
                },
                is_affiliate: false,
            };
        },
        methods: {
            async getAffiliates() {
                const query = await db
                    .collection('affiliate')
                    .where('APP_BASE_URL', '==', window.location.host)
                    .get();
                if (!query.size) {
                    return (this.config = {
                        APP_BASE_URL: 'https://covid19pad.com/',
                        FEATURE_BOTTOM_HERO_BACKGROUND_URL:
                            'https://firebasestorage.googleapis.com/v0/b/covid19pad-672e5.appspot.com/o/logo.png?alt=media&token=f39e801a-2777-4910-9708-04dcc748bf15',
                        FEATURE_DESKTOP_IMAGE:
                            'https://firebasestorage.googleapis.com/v0/b/covid19pad-672e5.appspot.com/o/covidpadsend.png?alt=media&token=8c389b1b-1bd3-4121-b7d1-48b78370f529',
                        FEATURE_LAPTOP_IMAGE_1:
                            'https://firebasestorage.googleapis.com/v0/b/covid19pad-672e5.appspot.com/o/covidpadsurvey.png?alt=media&token=c4a23c09-166a-48f7-ae66-d3e408c179f0',
                        FEATURE_LAPTOP_IMAGE_2:
                            'https://firebasestorage.googleapis.com/v0/b/covid19pad-672e5.appspot.com/o/covidpadsend.png?alt=media&token=8c389b1b-1bd3-4121-b7d1-48b78370f529',
                        FEATURE_TOP_HERO_BACKGROUND_URL:
                            'https://firebasestorage.googleapis.com/v0/b/covid19pad-672e5.appspot.com/o/covidpadimac.png?alt=media&token=c0e9449a-139e-433f-982a-e925f5e2bfef',
                        HOME_IMAGE:
                            'https://firebasestorage.googleapis.com/v0/b/covid19pad-672e5.appspot.com/o/iphone_screen1.png?alt=media&token=75df87de-7ac9-4ab6-94eb-507b50d46197',
                        HOW_IT_WORKS_DESKTOP_IMAGE:
                            'https://firebasestorage.googleapis.com/v0/b/covid19pad-672e5.appspot.com/o/laptop.png?alt=media&token=1f2bee0a-fe41-4add-bfac-013f08887dfa',
                        HOW_IT_WORKS_DESKTOP_VIDEO:
                            'https://firebasestorage.googleapis.com/v0/b/covid19pad-672e5.appspot.com/o/coronademo2%20(1).mov?alt=media&token=f8476678-df67-4d95-812c-6f9a612f4b1a',
                        HOW_IT_WORKS_MOBILE_IMAGE:
                            'https://firebasestorage.googleapis.com/v0/b/covid19pad-672e5.appspot.com/o/iphone_blank.png?alt=media&token=73839f51-c2aa-4142-a388-917fb3bf02cf',
                        HOW_IT_WORKS_MOBILE_VIDEO:
                            'https://firebasestorage.googleapis.com/v0/b/covid19pad-672e5.appspot.com/o/iphone2%20(1).mov?alt=media&token=7914fa68-36a8-4501-9bba-00f9c9f2b2b2',
                        KIOSK_AD_VIDEO:
                            'https://firebasestorage.googleapis.com/v0/b/covid19pad-672e5.appspot.com/o/kiosk_demo.mov?alt=media&token=94692a78-d9bd-4fe6-9a74-fcb246eac8b4',
                        KIOSK_INTRODUCTION_URL:
                            'https://firebasestorage.googleapis.com/v0/b/covid19pad-672e5.appspot.com/o/WhatsApp%20Video%202020-07-31%20at%2012.54.42%20PM%20(1).mp4?alt=media&token=509e9559-9cda-4876-9db2-e52174752a62',
                        KIOSK_WALKTHROUGH_URL:
                            'https://firebasestorage.googleapis.com/v0/b/covid19pad-672e5.appspot.com/o/WhatsApp%20Video%202020-07-31%20at%2012.54.47%20PM%20(1).mp4?alt=media&token=13cba138-d523-4118-832e-ea273edbcf2c',
                        LOGO_PNG:
                            'https://firebasestorage.googleapis.com/v0/b/covid19pad-672e5.appspot.com/o/logo.png?alt=media&token=f39e801a-2777-4910-9708-04dcc748bf15',
                        MANDRILL_MESSAGES_SEND_TEMPLATE_API:
                            'https://mandrillapp.com/api/1.0/messages/send-template.json',
                        MOBILE_SURVEY_WALKTHROUGH_URL:
                            'https://firebasestorage.googleapis.com/v0/b/covid19pad-672e5.appspot.com/o/WhatsApp%20Video%202020-07-31%20at%2012.54.55%20PM%20(1).mp4?alt=media&token=95706d68-6baf-4d22-87f4-3ea841a4b06d',
                        SURVEY_CONTENT_URL: 'https://covidsurvey.web.app/',
                    });
                }
                this.is_affiliate = true;
                this.config = query.docs[0].data().config;
                return query.size;
            },
            getAffiliateStatus() {
                return this.is_affiliate
            }
        },
    };
};

export default {
    mixin,
};
